import { css } from '@emotion/react';
import { semantic_colors, shapes, text_styles } from '../../foundation';

export const input_chip_base_css = css`
  display: flex;
  align-items: center;
  border: 1px solid ${semantic_colors.border.primary};
  background: ${semantic_colors.background.surface};
  ${shapes.border_radius.small};
  ${text_styles.Body_13_Medium};
  white-space: nowrap;

  &:disabled {
    color: ${semantic_colors.content.disabled};
    background-color: ${semantic_colors.background.disabled};
  }
`;

export const list_item_enabled_css = css`
  cursor: pointer;
  transition: all 0.1s linear;
  background: ${semantic_colors.background.surface};
  &:hover {
    background: ${semantic_colors.accent.light};
  }
  &:active {
    background: rgba(71, 105, 247, 0.1);
  }
`;

export const list_item_selected_css = css`
  cursor: pointer;
  transition: all 0.1s linear;
  background: ${semantic_colors.accent.light};
  &:hover {
    background: rgba(71, 105, 247, 0.05);
  }
  &:active {
    background: rgba(71, 105, 247, 0.1);
  }
`;

export const list_item_checked_css = css`
  cursor: pointer;
  transition: all 0.1s linear;
  background: ${semantic_colors.background.surface};
  &:hover {
    background: ${semantic_colors.accent.light};
  }
  &:active {
    background: rgba(71, 105, 247, 0.1);
  }
`;

export const list_item_disabled_css = css`
  cursor: not-allowed;
  background: ${semantic_colors.background.disabled};
`;

export const getCss = (disabled: boolean, selected: boolean, checked: boolean) => {
  if (disabled) {
    return list_item_disabled_css;
  }
  if (selected) {
    return list_item_selected_css;
  }
  if (checked) {
    return list_item_checked_css;
  }
  return list_item_enabled_css;
};

export const getColor = (
  disabled: boolean,
  selected: boolean,
  checked: boolean,
  indeterminate: boolean,
  multiple: boolean,
) => {
  if (disabled) {
    return semantic_colors.content.disabled;
  }
  const isActive = multiple ? checked || indeterminate : checked || selected;
  return isActive ? semantic_colors.accent.primary : semantic_colors.content.primary;
};
